import { Link } from 'react-router';
import { Plus } from 'lucide-react';
import { WorkflowList } from '@/components/workflows/WorkflowList';

export function WorkflowsPage(): React.ReactElement {
  return (
    <div className="relative flex flex-1 flex-col overflow-hidden">
      <span aria-hidden className="fd-glow-sky pointer-events-none absolute inset-0 opacity-50" />
      <div className="relative flex items-start justify-between px-6 pb-3 pt-5">
        <div>
          <h1 className="text-lg font-semibold tracking-tight text-text-primary">Workflows</h1>
          <p className="mt-1 text-xs text-text-tertiary">
            Pre-baked agentic procedures · authored in{' '}
            <span className="font-mono text-text-secondary">.metis/workflows/</span>
          </p>
        </div>
        <Link
          to="/workflows/builder"
          className="inline-flex items-center gap-1.5 rounded-md border border-[oklch(0.82_0.17_60)] bg-[linear-gradient(180deg,oklch(0.78_0.17_60)_0%,oklch(0.68_0.17_52)_100%)] px-3 py-1.5 text-sm font-semibold text-primary-foreground shadow-[inset_0_1px_0_oklch(1_0_0/0.3),0_1px_2px_oklch(0_0_0/0.4)] transition-all hover:brightness-110"
        >
          <Plus className="size-4" strokeWidth={2.5} />
          New Workflow
        </Link>
      </div>
      <div className="relative flex-1 overflow-hidden px-6 pb-0 pt-1">
        <WorkflowList />
      </div>
    </div>
  );
}
